import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AlertDialogService } from "./../../components/_alert-dialog/alert-dialog.service";
import { Actionnaire } from "../../interfaces/Actionnaire";
import { ActionnaireDialogService } from "./actionnaire-dialog.service";

@Component({
  selector: "actionnaire-dialog",
  templateUrl: "actionnaire-dialog.html",
  standalone: false,
})
export class ActionnaireDialogComponent implements OnInit {
  actionnaire: Actionnaire;
  isLoading: boolean = false;

  constructor(
    public _dr: MatDialogRef<ActionnaireDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public actionnaire_ID: number,
    public _s: ActionnaireDialogService,
    private _alert: AlertDialogService
  ) {}

  ngOnInit(): void {
    this.getActionnaire();
  }

  getActionnaire(): void {
    this.isLoading = true;
    this._s.get(this.actionnaire_ID, (actionnaire: Actionnaire) => {
      this.actionnaire = actionnaire;
      this.isLoading = false;
    });
  }

  postActionnaire(): void {
    this.isLoading = true;
    this._s.post(this.actionnaire, (actionnaire: Actionnaire) => {
      this.actionnaire = actionnaire;
      this.isLoading = false;
    });
  }

  deleteActionnaire(): void {
    this._alert.openConfirm(
      "Voulez-vous vraiment supprimer cet actionnaire ?",
      () => {
        this.isLoading = true;
        this._s.delete(this.actionnaire.actionnaire_ID, () => {
          this.isLoading = false;
          this._dr.close(true);
        });
      }
    );
  }

  close(): void {
    this._dr.close(false);
  }
}
